import { useRecordContext } from "react-admin";
import ApproveModal from "components/CareerCenter/Partials/ApproveModal";
import { alumniRequests } from "api/alumniApi";

const ApproveAlumniProfile = () => {
  const record = useRecordContext();

  return (
    <ApproveModal
      title="Одобри"
      titleContent="Сигурен ли сте, че искате да одобрите този профил?"
      request={alumniRequests.approveAlumniProfile(record?.id)}
      successMessage="Успешно одобрен профил"
    />
  );
};

export default ApproveAlumniProfile;
